import { render, staticRenderFns } from "./WinnerIndicator.vue?vue&type=template&id=2fc44d59&"
import script from "./WinnerIndicator.vue?vue&type=script&lang=js&"
export * from "./WinnerIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports